import React, {memo} from "react";

export const IconRatingDelete = memo(({color}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11H9H5V9H9H11H15V11Z"
        fill={color || "#BA2E2E"}
      />
    </svg>
  );
});
